import { render, staticRenderFns } from "./Loading.vue?vue&type=template&id=21e1a637&scoped=true&"
import script from "./Loading.vue?vue&type=script&lang=ts&"
export * from "./Loading.vue?vue&type=script&lang=ts&"
import style0 from "./Loading.scss?vue&type=style&index=0&id=21e1a637&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.8_1f9b6d6a8c5e3033a639476f0cf6d876/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e1a637",
  null
  
)

export default component.exports